import React from 'react';
import { ArrowRightIcon } from '../../assets/Icons';
import { cn } from '../../utils/cn';
import type { ButtonProps } from '../../types';

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant = 'primary',
      size = 'md',
      children,
      textColor = 'text-black',
      showArrow,
      ...props
    },
    ref
  ) => {
    const baseStyles =
      'inline-flex items-center justify-center font-inter-semibold uppercase tracking-wide transition-all duration-200 focus:outline-none  disabled:opacity-50 disabled:cursor-not-allowed !outline-none';

    const variants = {
      primary: `bg-seeds-yellow ${textColor} hover:bg-hover-yellow focus:ring-0`,
      'primary-selected': `bg-seeds-orange ${textColor} hover:bg-hover-yellow focus:ring-0`,
      secondary: 'bg-seeds-dark text-white hover:bg-green-800 focus:ring-0',
      outline:
        'border border-seeds-dark text-seeds-yellow bg-transparent  focus:ring-0',
      cta: 'bg-[#121F19] text-white hover:opacity-90 focus:ring-0 rounded-full',
    } as const;

    const sizes = {
      xs: 'px-4 py-2 text-xs rounded-full',
      sm: 'px-6 py-3 text-xs md:text-sm rounded-full',
      md: 'px-6 py-3 text-base rounded-full',
      lg: 'px-8 py-4 text-lg rounded-full',
    };

    return (
      <button
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        ref={ref}
        {...props}
      >
        <span className='inline-flex items-center gap-3'>
          {children}
          {showArrow && <ArrowRightIcon className='w-5 h-5 -rotate-45' />}
        </span>
      </button>
    );
  }
);

Button.displayName = 'Button';

export { Button };
